module.exports = __webpack_public_path__ + "static/media/contract_uav.020fcf96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contract_uav.svg
// module id = 255
// module chunks = 0